// The only backend origin setting. Set this before building the frontend.
export const BACKEND_URL = (
  process.env.REACT_APP_API_BASE_URL || "https://tukuzabackend.onrender.com"
).replace(/\/+$/, "");
